import styled from "styled-components";

export const BackgroundCircle1 = styled.img`
   position: absolute;
   right: 0px;
   z-index: -1;
   @media(max-width: 700px) {
     display: none
   }   
`

export const BackgroundCircle1_2 = styled.img`
   position: absolute;
   right: 0px;
   z-index: -1;
   display: none;
   @media(max-width: 700px) {
     display: block
   }   
`

export const BackgroundCircle2 = styled.img`
   position: absolute;
   bottom: -800px;
   left: 0px;
   z-index: -1;
   @media(max-width: 600px) {
     bottom: -900px;
   }
`

export const BackgroundRectangle1 = styled.img`
   position: absolute;
   top: 2150px;
   right: 0px;
   z-index: -1;
   @media(max-width: 600px) {
     top: 2220px;
   }   
`

export const BackgroundCircle3 = styled.img`
   position: absolute;
   top: 2600px;
   left: 0px;
   z-index: -1;
   @media(max-width: 600px) {
      top: 2650px;
      left: 0px;
   }     
`

export const BackgroundCircle4 = styled.img`
   position: absolute;
   top: 5100px;
   right: 0px;
   z-index: -1;
   @media(max-width: 600px) {
      display: none;
   }    
`
export const BackgroundCircleSmall = styled.img`
   position: absolute;
   top: 5100px;
   right: 0px;
   z-index: -1;
   display: none;
   @media(max-width: 600px) {
      display: block;
      top: 5400px;
      right: 0px;
   }    
`

export const BackgroundRectangle2 = styled.img`
   position: absolute;
   top: 5990px;
   left: 0px;
   z-index: -1;
   @media(max-width: 600px) {
      top: 6270px;
      left: 0px;
   }    
`
